// extracted by css-extract-rspack-plugin
module.exports =  {"tabList":"WLiyQ","tabItem":"MgKkN","active":"oEyFq","black":"j1Ftp"};